import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/profil.png'


const _withScopeId = n => (_pushScopeId("data-v-3fc9668d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-content flex justify-content-center p-3" }
const _hoisted_2 = { class: "centered-content form-group p-5 md:p-6" }
const _hoisted_3 = { class: "flex flex-wrap md:flex-nowrap gap-4 mt-7" }
const _hoisted_4 = { class: "w-5rem flex md:justify-content-end" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-label font-bold mb-4" }, "Photo de profil", -1))
const _hoisted_7 = { class: "grid" }
const _hoisted_8 = { class: "col-12 md:col-3" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "profil-img border-circle",
  src: _imports_0,
  alt: "profil-picture"
}
const _hoisted_11 = { class: "col-12 md:col-9" }
const _hoisted_12 = { class: "flex flex-column gap-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "app-label-small font-bold" }, " Téléchargez une nouvelle photo ", -1))
const _hoisted_14 = { class: "flex flex-wrap md:flex-nowrap gap-4 mt-7" }
const _hoisted_15 = { class: "w-5rem flex md:justify-content-end" }
const _hoisted_16 = { class: "w-full" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-label font-bold mb-3" }, "Identité", -1))
const _hoisted_18 = { class: "grid" }
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "flex flex-wrap md:flex-nowrap gap-4 mt-7" }
const _hoisted_22 = { class: "w-5rem flex md:justify-content-end" }
const _hoisted_23 = { class: "w-full" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-label font-bold mb-3" }, "Contact", -1))
const _hoisted_25 = { class: "grid" }
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = { class: "col-12" }
const _hoisted_28 = {
  key: 0,
  class: "flex justify-content-end align-items-end pt-4 pb-2"
}
const _hoisted_29 = { class: "flex flex-wrap md:flex-nowrap gap-4 mt-7" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-5rem" }, null, -1))
const _hoisted_31 = { class: "w-full" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-label font-bold mb-3" }, "Email", -1))
const _hoisted_33 = { class: "flex app-label text-gray-l1 mb-3" }
const _hoisted_34 = { class: "flex flex-wrap md:flex-nowrap gap-4 mt-7" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-5rem" }, null, -1))
const _hoisted_36 = { class: "w-full" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-label font-bold mb-3" }, "Mot de passe", -1))

import { computed, reactive, onMounted, toRefs, ref } from 'vue'
import { useFieldWatcher, useFieldWatcherGroup } from '@/composables/fieldWatcher'
import { useVuelidate } from '@vuelidate/core'
import { phone_number } from '@/utils/i18n-validators'
import hemisphereService from '@/services/hemisphere.service'
import { useToast } from 'primevue/usetoast'
import { useSession } from '@/composables/auth'
import EmailChangeDialog from '@/components/EmailChangeDialog.vue'
import PasswordChangeDialog from '@/components/PasswordChangeDialog.vue'

// store

export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfile',
  setup(__props) {

const { user: sessionUser, setUser } = useSession()
const toast = useToast()
const user = computed(() => sessionUser.value)

// form fields
const state = reactive({
  userProfile: {
    firstname: '',
    lastname: '',
    perso_phone: '',
    pro_phone: ''
  }
})

const { firstname, lastname, perso_phone, pro_phone } = toRefs(state.userProfile)

const emailChangeDialog = ref(null)
const passwordChangeDialog = ref(null)

//vuelidate
const rules = {
  userProfile: {
    perso_phone: {
      phone_number
    },
    pro_phone: {
      phone_number
    }
  }
}
const v$ = useVuelidate(rules, state)

const pictureSection = reactive({
  modifed: false,
  filledCount: user.value.picture_url ? 1 : 0,
  totalCount: 1
})

// sections
const firstnameField = useFieldWatcher(
  firstname,
  computed(() => user.value.first_name)
)
const lastnameField = useFieldWatcher(
  lastname,
  computed(() => user.value.last_name)
)
const persophoneField = useFieldWatcher(
  perso_phone,
  computed(() => user.value.perso_phone)
) //
const prophoneField = useFieldWatcher(
  pro_phone,
  computed(() => user.value.pro_phone)
)

const identityGroup = reactive(useFieldWatcherGroup([firstnameField, lastnameField]))

const contactGroup = reactive(useFieldWatcherGroup([persophoneField, prophoneField]))

function reset() {
  identityGroup.$reset()
  contactGroup.$reset()
}

const dataModified = computed(() => identityGroup.modified || contactGroup.modified)

async function updateProfile() {
  try {
    const userChanges: any = {}
    if (firstnameField.modified.value) {
      let value = firstnameField.field.value
      if (typeof value == 'undefined') value = ''
      userChanges.first_name = value
    }
    if (lastnameField.modified.value) {
      let value = lastnameField.field.value
      if (typeof value == 'undefined') value = ''
      userChanges.last_name = value
    }
    if (persophoneField.modified.value) {
      let value = persophoneField.field.value
      if (typeof value == 'undefined') value = ''
      userChanges.perso_phone = value
    }
    if (prophoneField.modified.value) {
      let value = prophoneField.field.value
      if (typeof value == 'undefined') value = ''
      userChanges.pro_phone = value
    }
    const resp = await hemisphereService.updateUser(userChanges)
    setUser(resp.data)
    toast.add({
      severity: 'success',
      summary: 'Profil mis à jour',
      life: 3000
    })
    reset()
  } catch (error) {
    console.log(error)
  }
}

async function updateUserPicture(event: any) {
  let file = event.files[0]
  hemisphereService.sendUserPicture({ photo: file }).then((resp) => {
    hemisphereService.getMyUserInfos().then((response) => {
      setUser(response.data)
      pictureSection.filledCount = 1
    })
  })
}

async function deleteUserPicture(event: any) {
  hemisphereService.deleteUserPicture().then((resp) => {
    hemisphereService.getMyUserInfos().then((response) => {
      setUser(response.data)
      pictureSection.filledCount = 0
    })
  })
}

onMounted(() => {
  reset()
})

function changeEmail() {
  emailChangeDialog.value.show()
}
function changePassword() {
  passwordChangeDialog.value.show()
}

return (_ctx: any,_cache: any) => {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InputSectionTag = _resolveComponent("InputSectionTag")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_InputBlock = _resolveComponent("InputBlock")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: "/home" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_button, {
              buttonType: "secondary",
              buttonSize: "s",
              buttonText: "Retour",
              iconName: "ci-arrows-back"
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_InputSectionTag, { data: pictureSection }, null, 8, ["data"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_unref(user).picture_url)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "profil-img border-circle",
                      src: _unref(user).picture_url,
                      alt: "profil-picture"
                    }, null, 8, _hoisted_9))
                  : (_openBlock(), _createElementBlock("img", _hoisted_10))
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_FileUpload, {
                    mode: "basic",
                    ref: "imageUpload",
                    accept: "image/*",
                    customUpload: true,
                    onUploader: updateUserPicture,
                    auto: true,
                    chooseLabel: "Choisir un fichier",
                    class: "secondary m"
                  }, null, 512),
                  (_unref(user).picture_url)
                    ? (_openBlock(), _createBlock(_component_app_button, {
                        key: 0,
                        buttonType: "secondary",
                        buttonSize: "s",
                        buttonText: "Supprimer",
                        onClick: deleteUserPicture,
                        iconName: "ci-action-delete",
                        buttonStyle: "danger",
                        class: "w-min"
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_InputSectionTag, { data: identityGroup }, null, 8, ["data"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_InputBlock, {
                  label: "nom",
                  modelValue: _unref(lastname),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(lastname) ? (lastname).value = $event : null))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_InputBlock, {
                  label: "prénom",
                  modelValue: _unref(firstname),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(firstname) ? (firstname).value = $event : null))
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_InputSectionTag, { data: contactGroup }, null, 8, ["data"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_InputBlock, {
                  label: "Téléphone personnel",
                  modelValue: _unref(v$).userProfile.perso_phone.$model,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).userProfile.perso_phone.$model) = $event)),
                  vuelidate: _unref(v$).userProfile.perso_phone
                }, null, 8, ["modelValue", "vuelidate"])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_InputBlock, {
                  label: "Téléphone professionnel",
                  modelValue: _unref(v$).userProfile.pro_phone.$model,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).userProfile.pro_phone.$model) = $event)),
                  vuelidate: _unref(v$).userProfile.pro_phone
                }, null, 8, ["modelValue", "vuelidate"])
              ])
            ])
          ])
        ]),
        (_unref(dataModified))
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createVNode(_component_app_button, {
                buttonType: "main",
                buttonSize: "m",
                buttonText: "Enregistrer les modifications",
                disabled: _unref(v$).userProfile.$invalid,
                onClick: updateProfile,
                class: "w-full md:w-auto"
              }, null, 8, ["disabled"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(user).email), 1),
            _createElementVNode("span", {
              class: "flex app-label-micro text-primary-blue uppercase cursor-pointer",
              onClick: changeEmail
            }, _toDisplayString(_ctx.$t('homeview.profil-left-bar.update-email')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("span", {
              class: "flex app-label-micro text-primary-blue uppercase cursor-pointer",
              onClick: changePassword
            }, _toDisplayString(_ctx.$t('homeview.profil-left-bar.update-password')), 1)
          ])
        ])
      ])
    ]),
    _createVNode(EmailChangeDialog, {
      ref_key: "emailChangeDialog",
      ref: emailChangeDialog
    }, null, 512),
    _createVNode(PasswordChangeDialog, {
      ref_key: "passwordChangeDialog",
      ref: passwordChangeDialog
    }, null, 512)
  ], 64))
}
}

})